import md5 from 'blueimp-md5'
export default md5



// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/tools/md5/index.js